/**
 * O estado da gravação como a sala o publica: o metadado do LiveKit `{ meetingEndsAt?, recording?: { state, ... } }`, que o
 * servidor monta INTEIRO a cada mudança (docs/specs/otto/RECORDING.md §2 D5). É o único canal que serve ao atendente e ao
 * convidado, e atualiza ao vivo sem recarregar.
 */
export const ROOM_RECORDING_STATE = Object.freeze({ NONE: 'none', REQUESTED: 'requested', RECORDING: 'recording' });

const NONE = Object.freeze({ state: ROOM_RECORDING_STATE.NONE, requestId: null, recordingId: null, startedAt: null });

/**
 * Lê o metadado da sala. Qualquer coisa que não seja um estado conhecido vira "sem gravação" (nunca lança): um metadado
 * estranho não pode quebrar a sala nem inventar um aviso.
 * @param {string|undefined|null} metadata
 * @returns {{ state: 'none'|'requested'|'recording', requestId: string|null, recordingId: string|null, startedAt: string|null }}
 */
export function parseRoomRecording(metadata) {
    if (typeof metadata !== 'string' || metadata === '') return NONE;
    try {
        const recording = JSON.parse(metadata)?.recording;
        if (!recording || typeof recording !== 'object') return NONE;
        if (recording.state !== ROOM_RECORDING_STATE.REQUESTED && recording.state !== ROOM_RECORDING_STATE.RECORDING) return NONE;
        return {
            state: recording.state,
            requestId: typeof recording.requestId === 'string' ? recording.requestId : null,
            recordingId: typeof recording.recordingId === 'string' ? recording.recordingId : null,
            startedAt: typeof recording.startedAt === 'string' ? recording.startedAt : null,
        };
    } catch {
        return NONE;
    }
}
